<div
  class="modal fade show d-block"
  tabindex="-1"
  role="dialog"
  *ngIf="currentNotification"
>
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="d-flex justify-content-between align-items-center">
          <div></div>
          <button
            type="button"
            class="close btn d-flex justify-content-end"
            (click)="handleCancel(currentNotification)"
            aria-label="Close"
          >
            <img
              src="https://storage.googleapis.com/komerce/assets/LP-Komcard/close-circle.svg"
              alt="close"
              width="20px"
            />
          </button>
        </div>
        <div class="d-flex flex-column gap-2 py-1 pr-2">
          <img [src]="currentNotification.media_url" alt="media" style="max-width: 100%" />
          <div class="d-flex flex-column mt-1">
            <h5 class="text-black">
              <strong>{{ currentNotification.title }}</strong>
            </h5>
            <div class="d-flex gap-2">
              <span>
                {{ currentNotification.description }}
                <strong class="font-bold">
                  <a
                    [href]="currentNotification.url_link"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-black text-decoration-none"
                  >
                    {{ currentNotification.url_link }}
                  </a>
                </strong>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
